"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _RequestProvider = _interopRequireDefault(require("../../../../RequestProvider")),
    _ConfirmationModal = _interopRequireDefault(require("../components/ConfirmationModal")),
    _api = require("../api");

function ConfirmationModal(a) {
  var b = a.organisationName,
      c = a.visible,
      d = a.hideModal,
      e = a.assetId,
      f = a.confirmModalAction,
      g = a.onConfirmation;
  return _react["default"].createElement(_RequestProvider["default"], {
    requests: {
      archiveAsset: (0, _api.archiveAssetApi)(),
      unarchiveAsset: (0, _api.unarchiveAssetApi)()
    }
  }, function (a) {
    var h = a.archiveAsset,
        i = a.unarchiveAsset;
    return _react["default"].createElement(_ConfirmationModal["default"], {
      organisationName: b,
      archiveAsset: h,
      unarchiveAsset: i,
      visible: c,
      hideModal: d,
      assetId: e,
      confirmModalAction: f,
      onConfirmation: g
    });
  });
}

var _default = (0, _react.memo)(ConfirmationModal);

exports["default"] = _default;